import styled from 'styled-components';
import { SummaryLegalTextStyled } from '@components/SummaryLegalText/SummaryLegalTextStyled';
import { rem } from 'polished';

export const SummaryLegalTextStyledDS = styled(SummaryLegalTextStyled)`
    p {
        font-size: ${({ theme }) => theme.fontSizes.h6};
        color: ${({ theme }) => theme.colors.grey29};
        line-height: ${rem(18)};
    }
`;
